export default __webpack_public_path__ + "static/media/start-button.eee2d167.svg";